export const noAssessmentText = {
    NoAssessment: {
        en: "No Assessment Found!",
        mr: "कोणतेही मूल्यांकन आढळले नाही!",
    },
    Message: {
        en: "There is no assessment assigned for you at the moment.",
        mr: "सध्या तुमच्यासाठी कोणतेही मूल्यांकन नियुक्त केलेले नाही.",
    },
    GoBack: {
        en: "Go back",
        mr: "परत जा",
    },
};
